import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
export const ProductReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const products = [{
    id: 1,
    name: 'BioBalance Pro Prebiotic',
    rating: 4.5,
    review: 'High-quality prebiotic with scientifically validated strains. Our testing confirmed label accuracy and good survivability.',
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Prebiotics'
  }, {
    id: 2,
    name: 'MicrobiomePlus Daily',
    rating: 3.5,
    review: 'Contains beneficial strains but our testing showed lower CFU counts than claimed on packaging.',
    image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbde88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Probiotics'
  }, {
    id: 3,
    name: 'GutHealth Digestive Enzymes',
    rating: 4,
    review: 'Effective enzyme blend with good stability. Our tests confirmed activity levels match label claims.',
    image: 'https://images.unsplash.com/photo-1550572017-edd951b55104?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Digestive Support'
  }, {
    id: 4,
    name: 'BiomeScan Home Test Kit',
    rating: 2.5,
    review: 'Limited accuracy compared to clinical testing. Results showed significant inconsistencies in repeat samples.',
    image: 'https://images.unsplash.com/photo-1576671414121-aa0c81c869e3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    category: 'Testing Kits'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % products.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + products.length) % products.length);
  };
  const renderStars = rating => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    for (let i = 0; i < fullStars; i++) {
      stars.push(<StarIcon key={`full-${i}`} size={18} className="fill-yellow-400 text-yellow-400" data-id="element-1332" />);
    }
    if (hasHalfStar) {
      stars.push(<div key="half" className="relative" data-id="element-1333">
          <StarIcon size={18} className="text-gray-300" data-id="element-1334" />
          <div className="absolute top-0 left-0 w-1/2 overflow-hidden" data-id="element-1335">
            <StarIcon size={18} className="fill-yellow-400 text-yellow-400" data-id="element-1336" />
          </div>
        </div>);
    }
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<StarIcon key={`empty-${i}`} size={18} className="text-gray-300" data-id="element-1337" />);
    }
    return stars;
  };
  return <section id="reviews" className="py-16 bg-white" data-id="element-1338">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1339">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-1340">
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-4" data-id="element-1341">
            Product Reviews
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1342">
            Independent testing and evaluation of microbiome-related products
          </p>
        </motion.div>
        <div className="relative" data-id="element-1343">
          <div className="overflow-hidden" data-id="element-1344">
            <motion.div className="flex" initial={{
            opacity: 1
          }} animate={{
            x: `-${currentIndex * 100}%`
          }} transition={{
            duration: 0.5,
            ease: 'easeInOut'
          }} data-id="element-1345">
              {products.map(product => <div key={product.id} className="min-w-full px-4" data-id="element-1346">
                  <div className="bg-gray-50 rounded-xl overflow-hidden shadow-md flex flex-col md:flex-row" data-id="element-1347">
                    <div className="md:w-1/3 h-64 md:h-auto" data-id="element-1348">
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover" data-id="element-1349" />
                    </div>
                    <div className="p-8 md:w-2/3" data-id="element-1350">
                      <div className="mb-2" data-id="element-1351">
                        <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full uppercase font-semibold tracking-wide" data-id="element-1352">
                          {product.category}
                        </span>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1353">
                        {product.name}
                      </h3>
                      <div className="flex items-center mb-4" data-id="element-1354">
                        <div className="flex mr-2" data-id="element-1355">
                          {renderStars(product.rating)}
                        </div>
                        <span className="text-gray-600 text-sm" data-id="element-1356">
                          {product.rating}/5
                        </span>
                      </div>
                      <p className="text-gray-700 mb-6 text-lg" data-id="element-1357">
                        {product.review}
                      </p>
                      <button className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors duration-200" data-id="element-1358">
                        Read Full Review
                      </button>
                    </div>
                  </div>
                </div>)}
            </motion.div>
          </div>
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md z-10 text-gray-800 hover:text-blue-600 transition-colors duration-200" aria-label="Previous product" data-id="element-1359">
            <ChevronLeftIcon size={24} data-id="element-1360" />
          </button>
          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 shadow-md z-10 text-gray-800 hover:text-blue-600 transition-colors duration-200" aria-label="Next product" data-id="element-1361">
            <ChevronRightIcon size={24} data-id="element-1362" />
          </button>
          <div className="flex justify-center mt-6" data-id="element-1363">
            {products.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`h-2 w-2 rounded-full mx-1 ${currentIndex === index ? 'bg-blue-600' : 'bg-gray-300'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-1364" />)}
          </div>
        </div>
      </div>
    </section>;
};